import React, { ChangeEvent, HTMLProps } from 'react';

interface PropType {
    name: string;
    value: string | null | undefined;
    placeholder?: string;
    hint?: string;
    onChangeHandler: (value: any, name: string) => void;
}

const InputUrl = (props: HTMLProps<HTMLInputElement> & PropType) => {
    const { value, placeholder, name, onChangeHandler, hint, ...otherProps } = props;
    return (
        <>
            <input
                type="url"
                value={value ? value : ''}
                onChange={(e: ChangeEvent<any>) => { onChangeHandler(e.currentTarget.value, name); }}
                className="form-control"
                placeholder={placeholder}
                name={name}
                {...otherProps}
            />
            {hint && <span className="form-text m-b-none">{hint}</span>}
        </>
    );
};

export default InputUrl;



// WEBPACK FOOTER //
// ./src/components/Form/InputUrl.tsx